module.exports = __webpack_public_path__ + "media/images/icons/material/bookmark-8a9b7dfb7ac2ee9644352279c5aaaecb.svg";